<template>
  <span v-if="text"
    ><span v-if="prependText" class="mx-1">{{ prependText }}</span
    >{{ text }}
  </span>
</template>

<script setup lang="ts">
import type { components } from '#root/types/directus'
import { computed } from 'vue'

const props = defineProps<{
  prependText?: string
  value: components['schemas']['ItemsReviews']
}>()

const text = computed(() => {
  const parts = []

  if (props.value) {
    if (props.value.name) parts.push(props.value.name)
    if (props.value.title) parts.push(props.value.title)
    if (props.value.organization_name) parts.push(props.value.organization_name)
    if (props.value.location_name) parts.push(props.value.location_name)
  }

  return parts.join(', ')
})
</script>
